const normalize = (text) =>
  text?.toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/’/g, "'")  // harmonise les apostrophes
    .trim();

const getFilteredBooks = (bookDatabase, answers) => {
  const selectedTags = Array.isArray(answers[3]) ? answers[3] : [];

  const books = bookDatabase.filter((book) => {
    if (
      normalize(book.category1) !== normalize(answers[0]) ||
      normalize(book.category2) !== normalize(answers[1]) ||
      normalize(book.category3) !== normalize(answers[2])
    ) {
      return false;
    }

    if (answers[4] === "Oui") {
      const pages = parseInt(book.nbp, 10) || 999;
      if (pages > 250) return false;
    }

    if (answers[5] === "Oui") {
      const tags = normalize(book.tags || "");
      const isGuide = tags.includes("outil") || tags.includes("guide");
      if (!isGuide) return false;
    }

    return true;
  });

  const scoredBooks = books.map(book => {
    const bookTags = (book.tags || "")
      .split(",")
      .map(t => normalize(t));

    const tagMatches = selectedTags.filter(tag => 
      bookTags.includes(normalize(tag))
    ).length;

    return { ...book, matchScore: tagMatches };
  });

  return scoredBooks
    .filter(book => book.matchScore > 0)
    .sort((a, b) => b.matchScore - a.matchScore);
};

export default getFilteredBooks;
